import {I18n} from '@lingui/core';
import {I18nProvider} from '@lingui/react';
import React, {FC, useMemo} from 'react';

import {Localizer} from '../../src/store/stateless/internationalizationSelectors';
import {InternalizationContextProvider} from './internationalizationContext';

/*
 * Props.
 */

interface InternationalizationProviderProps {
  i18n: I18n;
  localize: Localizer;
}

/*
 * Component.
 */

export const InternationalizationProvider: FC<InternationalizationProviderProps> = (props) => {
  const {i18n, localize, children} = props;
  const context = useMemo(() => ({i18n, localize}), [i18n, localize]);

  return (
    <InternalizationContextProvider value={context}>
      <I18nProvider i18n={i18n} language={i18n.language}>
        {children}
      </I18nProvider>
    </InternalizationContextProvider>
  );
};
